<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    ثبت موقعیت
                    <button data-menu="HelpMenu" class="position-static"><i class="fa fa-question-circle helpIco"></i></button>
                    <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>
            <div class="card card-style">
                <div class="content mb-0">

                    <div>
                        <button class="btn btn-xxs mb-2 btn-full bg-green2-dark rounded-sm font-900 w-100" @click="getCurrentPosition">
                            <i class="fa fa-map-marker-alt font-10 ml-2"></i>
                            دریافت موقعیت
                        </button>
                        <p class="text-danger" v-if="v$.userPresenceModel.mapLocation.required.$invalid && v$.userPresenceModel.mapLocation.$dirty">موقعیت جغرافیایی مشخص نشده است.</p>
                    </div>


                    <div class="mb-4">
                        <l-map style="height:300px" :zoom="16" :center="mapLocationObject" v-if="mapLocationObject!=null">
                            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                            <l-marker :lat-lng="mapLocationObject"></l-marker>
                        </l-map>
                    </div>



                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-calendar brand-color"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : userPresenceModel.presenceDate!==null}">تاریخ </span>
                        <input type="text"
                               class="form-control ltr d-inline-block"
                               v-model="userPresenceModel.presenceDate"
                               id="endDT" />
                    </div>



                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-file-alt brand-color"></i>
                        <span class="color-highlight input-style-1-active">نوع :</span>
                        <select class="form-control" type="text" v-model="userPresenceModel.userPresenceTypeId" @change="setTitle">
                            <option value=0>ثبت موقعیت</option>
                            <option value=1>ورود</option>
                            <option value=2>خروج</option>
                        </select>
                    </div>

                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check brand-color"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : userPresenceModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="userPresenceModel.title" @input="v$.userPresenceModel.title.$touch()" :class="{invalid:v$.userPresenceModel.title.$error}">
                        <p class="text-danger" v-if="v$.userPresenceModel.title.required.$invalid && v$.userPresenceModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>

                    <div class="card mx-0 mb-3">
                        <!--<div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
                        <button data-toggle="collapse" data-target="#collapse-description">
                            <i class="fa fa-edit mt-2"></i>
                            <span>توضیحات</span>
                            <i class="fa fa-angle-down"></i>
                        </button>
                    </div>-->

                        <div>
                            <textarea v-model="userPresenceModel.description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px" placeholder="توضیحات"></textarea>
                            <button class="btn btn-link speechToTextBtn mb-3" @pointerdown="startR"
                                    @pointerup="stopR">
                                <span :class="btnRecord">
                                    <span class="speechToTextBtn-text" v-if="showType">شروع به صحبت کنید...</span>
                                </span>
                                <img class="ml-3" v-if="showType" src="/assets/images/wave.gif" width="38" height="38" />
                            </button>

                        </div>
                    </div>
                    <att-list :docId="0" v-bind:destination="'UserPresence'" @setAttList="SetAttList($event)" @attInProgress="AttInProgress($event)" :canAdd="true" :canDelete="true" :oldAttList="[]" :hasLocation="false"></att-list>

                    <button type="button" :disabled="Loading || attInProgress" class="btn btn-xxs mt-2 mb-3 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateUserPresence">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                    <!--<button type="button" v-if="isAutomaticStart==false" class="btn btn-xxs mt-2 mb-3 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="StartAutomatic">
                    <i class="fa fa-check font-10 ml-2"></i>
                    شروع موقعیت اتوماتیک
                </button>
                <button type="button" v-if="isAutomaticStart==true" class="btn btn-xxs mt-2 mb-3 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="StopAutomatic">
                    <i class="fa fa-check font-10 ml-2"></i>
                    توقف موقعیت اتوماتیک
                </button>-->
                </div>
            </div>
        </div>
        <date-picker type="date" v-model="userPresenceModel.presenceDate" format="jYYYY/jMM/jDD" element="endDT" />

        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
            </div>
        </transition>
        <Help-Menu v-if="isKarnegasht==false" title="معرفی اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
        <Help-Menu v-if="isKarnegasht==true" title="معرفی اپلیکیشن کارنگاشت" keyEn="TaskList"></Help-Menu>


    </div>
</template>
<script>
    import useVuelidate from '@vuelidate/core'
    import {
        required
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import { maska } from 'maska'
    import AttList from '../Components/AttList.vue';
    import DatePicker from 'vue3-persian-datetime-picker';
    import HelpMenu from '../Components/HelpMenu.vue';
    import "leaflet/dist/leaflet.css"
    import { LMap, LMarker, LTileLayer } from "@vue-leaflet/vue-leaflet";
    import { Device } from '@capacitor/device';
    import { Geolocation } from "@capacitor/geolocation";
    import { latLng } from "leaflet";
    import { Icon } from 'leaflet';
    import VueSimpleAlert from 'vue3-simple-alert';
    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition         

    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });

    export default {
        components: {
            DatePicker,
            "att-list": AttList,
            LMap,
            LMarker,
            "Help-Menu": HelpMenu,
            LTileLayer
        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                attInProgress: false,
                modified: false,
                isAutomaticStart: false,
                isAutomatic: false,
                logDeviceInfo: null,
                mapLocationObject: null,
                showType: false,
                sr: null,
                btnRecord: "btn btn-danger speechToTextBtn-i",
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                userPresenceModel: {
                    title: null,
                    userPresenceId: 0,
                    userId: 0,
                    isAutomatic: false,
                    description: " ",
                    createDateTime: null,
                    attList: [],
                    presenceDate: null,
                    mapLocation: null,
                    countryTitle: null,
                    goBack: true,
                    cityTitle: null,
                    address: null,
                    ipAddress: null,
                    deviceInfo: " ",
                    userPresenceTypeId: 0
                },

            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            propsToWatch() {
                return `${this.userPresenceModel.title}|${this.userPresenceModel.description}`;
            },

        },
        watch: {
            propsToWatch: {
                handler: function () {
                    console.log(this.modified);
                    this.modified = true;
                },
                deep: true
            },
        },
        async created() {
            this.userPresenceModel.title = "ثبت موقعیت";
            this.getServerDateTime();
            this.getCurrentPosition();
            //this.interval = setInterval(() => this.getCurrentPosition(), 60000);
        },
        methods: {
            startR() {
                try {
                    this.sr.start();
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                } catch (error) {
                    console.error(error);
                    this.showType = true;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },
            stopR() {
                try {
                    this.sr.stop();
                    this.showType = false;
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                } catch (error) {
                    console.error(error);
                    this.showType = false;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },

            CreateUserPresence() {
                this.userPresenceModel.isAutomatic = false;
                this.isAutomatic = false;
                this.SendUserPresence();

            },
            SendUserPresence() {
                if (this.isAutomatic) {
                    this.userPresenceModel.isAutomatic = true;
                    this.getCurrentPosition();
                }
                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.modified = false;
                    this.$store.dispatch("CreateUserPresence", this.userPresenceModel);
                    this.modified = false;
                }

            },
            StartAutomatic() {
                this.isAutomatic = true;
                this.isAutomaticStart = true;
                this.userPresenceModel.isAutomatic = true;
                this.interval = setInterval(() => this.SendUserPresence(), 60000);
            },
            StopAutomatic() {
                this.isAutomatic = false;
                this.isAutomaticStart = false;
                this.userPresenceModel.isAutomatic = false;
                clearInterval(this.interval)
                //this.interval = setInterval(() => this.SendUserPresence(), 60000);
            },
            async getCurrentPosition() {
                try {
                    const coordinates = await Geolocation.getCurrentPosition({
                        enableHighAccuracy: true
                    });
                    console.log(coordinates.coords.latitude);
                    this.userPresenceModel.mapLocation = coordinates.coords.latitude + "," + coordinates.coords.longitude;
                    this.mapLocationObject = latLng(coordinates.coords.latitude, coordinates.coords.longitude);
                    this.userPresenceModel.address = await this.getAddress();
                }
                catch (ex) {
                    console.log(ex);
                    this.showErrorMessage("خطا در دریافت موقعیت مکانی. لطفا از روشن بودن Location دستگاه خود مطمئن شوید و مجددا تلاش کنید.");
                }

            },
            checkLocation() {
                window.plugins.locationAccuracy.canRequest(function (canRequest) {
                    if (canRequest) {
                        window.plugins.locationAccuracy.request(function (success) {
                            console.log("Successfully requested accuracy: " + success.message);
                        }, function (error) {
                            console.error("Accuracy request failed: error code=" + error.code + "; error message=" + error.message);
                            if (error.code !== window.plugins.locationAccuracy.ERROR_USER_DISAGREED) {
                                if (window.confirm("Failed to automatically set Location Mode to 'High Accuracy'. Would you like to switch to the Location Settings page and do this manually?")) {
                                    window.plugins.diagnostic.switchToLocationSettings();
                                }
                            }
                        }, window.plugins.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY);
                    } else {
                        // request location permission and try again
                    }
                });
            },
            async GetDeficeInfo() {
                this.logDeviceInfo = await Device.getInfo();

                this.userPresenceModel.deviceInfo = this.logDeviceInfo.model + " " + this.logDeviceInfo.platform + " " + this.logDeviceInfo.operatingSystem + " " + this.logDeviceInfo.osVersion + " " + this.logDeviceInfo.webViewVersion;

            },
            getServerDateTime() {
                this.$http.get("Task/GetServerDateTime")
                    .then(data => {
                        this.userPresenceModel.presenceDate = data.data.split("_")[0];
                        this.userPresenceModel.createDateTime = data.data.replace("_", " ");

                    });

            },
            SetAttList(e) {
                console.log(e);
                this.userPresenceModel.attList = e;
            },
            async getAddress() {
                //this.loading = true;
                let address = "Unresolved address";
                try {
                    const { lat, lng } = this.mapLocationObject;
                    const result = await fetch(
                        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&accept-language=fa-IR`
                    );
                    if (result.status === 200) {
                        const body = await result.json();
                        address = body.display_name;
                    }
                } catch (e) {
                    console.error("Reverse Geocode Error->", e);
                }
                //this.loading = false;
                return address;
            },
            AttInProgress(e) {
                this.attInProgress = e;
            },
            setTitle() {
                if (this.userPresenceModel.userPresenceTypeId == 1) {
                    this.userPresenceModel.title = "ورود";
                }
                else if (this.userPresenceModel.userPresenceTypeId == 2) {
                    this.userPresenceModel.title = "خروج";
                }
                else if (this.userPresenceModel.userPresenceTypeId == 0) {
                    this.userPresenceModel.title = "ثبت موقعیت";
                }
                else {
                    this.userPresenceModel.title = "";
                }
            },
            pauseVid(id) {
                console.log(id);
                if (id != null) {
                    console.log("pause");
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
        },
        async mounted() {
            try {
                this.sr = new Recognition()
                this.sr.continuous = true
                this.sr.interimResults = true
                this.sr.lang = 'fa-IR';
                var rest = "";
                this.sr.onstart = () => {
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                }
                this.sr.onresult = (evt) => {
                    rest = evt.results[evt.results.length - 1][0].transcript;
                }
                this.sr.onend = () => {
                    rest = rest.replaceAll("علامت سوال", "؟");
                    rest = rest.replaceAll("علامت تعجب", "!");
                    rest = rest.replaceAll("علامت بزرگتر", ">");
                    rest = rest.replaceAll("علامت کوچکتر", "<");
                    rest = rest.replaceAll("پرانتز باز", "(");
                    rest = rest.replaceAll("پرانتز بسته", ")");
                    rest = rest.replaceAll("شارپ", "#");
                    rest = rest.replaceAll("ستاره", "*");
                    rest = rest.replaceAll("دو نقطه", ": ");
                    rest = rest.replaceAll("نقطه ویرگول", "; ");
                    rest = rest.replaceAll("نقطه", ". ");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("پاراگراف جدید", "\n");
                    rest = rest.replaceAll("پاراگراف بعد", "\n");
                    rest = rest.replaceAll("پاراگراف بعدی", "\n");
                    rest = rest.replaceAll("پاراگراف", "\n");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("خط بعدی", "\n");
                    rest = rest.replaceAll("خط بعد", "\n");
                    rest = rest.replaceAll("خط جدید", "\n");

                    if (this.userPresenceModel.description == null || this.userPresenceModel.description == "null")
                        this.userPresenceModel.description = "";
                    if (rest != null && rest != '')
                        this.userPresenceModel.description = this.userPresenceModel.description + " " + rest
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                    rest = "";
                    this.showType = false;
                }
            } catch (error) {
                console.error(error);
                // Expected output: ReferenceError: nonExistentFunction is not defined
                // (Note: the exact output may be browser-dependent)
            }

            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
            await this.GetDeficeInfo();
            document.addEventListener("deviceready", () => {
                this.checkLocation();
            });
            //setInterval(function () {
            //    console.log("342")
            //    this.getCurrentPosition();
            //}, 10000);
        },
        validations: {
            userPresenceModel: {
                title: {
                    required,
                },
                presenceDate: {
                    required
                },
                mapLocation: {
                    required
                }
            }


        },
        directives: { maska },
        beforeRouteLeave(to, from, next) {
            if (this.modified == true) {
                VueSimpleAlert.fire({
                    title: 'با بستن این صفحه تغییرات شما ذخیره نخواهد شد. آیا ادامه می دهید؟',
                    showCancelButton: true,
                    confirmButtonText: 'تأیید',
                    cancelButtonText: `انصراف`,
                }).then((result) => {
                    console.log(this.modified);

                    if (result.value == true) {
                        next();
                    } else {
                        next(false);
                    }
                })
            }
            else {
                next();
            }
        }

    };
</script>
